import React from 'react'
import './CenterBox.css'

const CenterBox = ({ children }) => <div className="CenterBox">{children}</div>

export default CenterBox



// WEBPACK FOOTER //
// ./src/components/CenterBox.js